import { create } from 'zustand';
import { ApiUtils, CustomerApi, type CustomerDataItem, type CustomerSearchParams, RequestStrategyEnum } from '@shared/api';

interface UseCustomersStore {
  loading: boolean;
  data: CustomerDataItem[];
  error: string | null;
  getCustomers: (params?: CustomerSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCustomersStore = create<UseCustomersStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getCustomers: ApiUtils.wrapperApi(async (params = {}, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CustomerApi.getCustomers(params, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
